import React from "react";
import { Button } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router";
import compose from "recompose/compose";
import PropTypes from "prop-types";

const styles = {
  button: {
    margin: 8,
  },
  contentHeaderMenuLink: {
    textDecoration: "none",
    color: "white",
    padding: 8,
  },
  content: {
    padding: "16px",
  },
};

function EditUserButton(props) {
  const { item, history } = props;

  function handleEditUser(id, type) {
    if (type === "Sales" || type === "sales") {
      history.push(`/admin-my-sales-rep/edit/${id}`);
    } else {
      history.push(`/admin-my-dealers/dealers/${id}/edit`);
    }
  }

  return (
    <div>
      {item?.role === "Sales" || item?.role === "sales" ? (
        <Button
          variant="contained"
          color="primary"
          style={styles.button}
          onClick={() => handleEditUser(item?.profile_id, item?.role)}
        >
          Edit Sales Rep Info
        </Button>
      ) : (
        <Button
          variant="contained"
          color="primary"
          style={styles.button}
          onClick={() => handleEditUser(item?.profile_id)}
        >
          Edit Dealer Info
        </Button>
      )}
    </div>
  );
}

EditUserButton.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default compose(withRouter, withStyles(styles))(EditUserButton);